module.exports = __webpack_public_path__ + "static/works-bg-4-a81cab16e560f68d3bcfca8a9de06f86.jpg";